import { isSupportWebp } from "./imageUrl";

type IParams = {
  quality?: number;
  useWebp?: boolean;
  maxWidth?: number;
  maxHeight?: number;
};

type IResult = {
  file: File;
  src: string;
};

export default function compressImg(
  file: File,
  params?: IParams
): Promise<IResult | null> {
  const {
    quality = 0.7,
    useWebp = true,
    maxWidth = Infinity,
    maxHeight = Infinity,
  } = params || {};
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const src = evt.target.result as string;
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");

        const minWidth = Math.min(img.width, maxWidth);
        const minHeight = Math.min(img.height, maxHeight);

        const ratio = Math.min(minWidth / img.width, minHeight / img.height);

        const width = img.width * ratio;
        const height = img.height * ratio;

        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        const type = useWebp && isSupportWebp() ? "image/webp" : file.type;
        if (canvas.toBlob) {
          canvas.toBlob(
            (blob) => {
              const minFile = new File([blob], file.name, {
                type,
              });
              resolve({
                file: minFile,
                src,
              });
            },
            type,
            quality
          );
        } else {
          const canvasURL = canvas.toDataURL(type, quality);
          const buffer = atob(canvasURL.split(",")[1]);
          let length = buffer.length;
          const bufferArray = new Uint8Array(new ArrayBuffer(length));
          while (length--) {
            bufferArray[length] = buffer.charCodeAt(length);
          }
          const minFile = new File([bufferArray], file.name, {
            type,
          });
          resolve({
            file: minFile,
            src,
          });
        }
      };
      img.onerror = () => {
        resolve(null);
      };
      img.src = src;
    };
    reader.onerror = () => {
      resolve(null);
    };
    reader.readAsDataURL(file);
  });
}
